module.exports = __webpack_public_path__ + "assets/pin-red.c7d8bd889cc7dc29a2641d3f1f74ba38.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/pin/pin-red.png
// module id = 521
// module chunks = 0